import { defer, type LoaderFunctionArgs } from "react-router-dom";
import { resolveLoaderResult } from "@/routes/loaderResult";
import { getM2PageInfo } from "../common/services";

function getDeviceId() {
  if (/Android|Adr/i.test(navigator.userAgent)) {
    return navigator.userAgent.split(";").pop() || "";
  }
  return navigator.userAgent.split(" ").pop() || "";
}

export function mgmLandingLoader({ request }: LoaderFunctionArgs) {
  const searchParams = new URL(request.url).searchParams;
  const shareCode = searchParams.get("shareCode") || "";
  const channelCode = searchParams.get("channelCode") || "";
  const resourceId = searchParams.get("resourceId") || "";
  const requestId = getDeviceId();

  return defer({
    coreData: resolveLoaderResult(
      getM2PageInfo(requestId, shareCode, channelCode, resourceId).then((info) => ({
        info,
        requestId,
        shareCode,
        channelCode,
        resourceId,
      })),
    ),
  });
}
